import { render, staticRenderFns } from "./BookingAddonsModal.vue?vue&type=template&id=53e14336"
import script from "./BookingAddonsModal.vue?vue&type=script&lang=js"
export * from "./BookingAddonsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports